import Countdown from './Countdown';
import Statistic, { StatisticProps } from './Statistic';
Statistic.Countdown = Countdown;
export { StatisticProps };
export default Statistic;
